export const ADVANCED_FEE_TAB_KEYS = {
    VOLUME_TIERS: 'volume-tiers',
    PRODUCT_TYPES: 'product-types',
    FREE_ADVANCES: 'free-advances',
};

export const ADVANCED_FEE_TABS = [
    { key: ADVANCED_FEE_TAB_KEYS.VOLUME_TIERS, label: 'Volume Tiers' },
    { key: ADVANCED_FEE_TAB_KEYS.PRODUCT_TYPES, label: 'Product Types' },
    { key: ADVANCED_FEE_TAB_KEYS.FREE_ADVANCES, label: 'Free Advances' },
];

/**
 * Maps each advanced-fee tab key to its corresponding `fee_enabled` state key.
 * The toggle on the card always controls the currently visible sub-section.
 */
export const TAB_ENABLED_KEY = {
    [ADVANCED_FEE_TAB_KEYS.VOLUME_TIERS]: 'volumeTiers',
    [ADVANCED_FEE_TAB_KEYS.PRODUCT_TYPES]: 'productTypes',
    [ADVANCED_FEE_TAB_KEYS.FREE_ADVANCES]: 'freeAdvances',
};
